import { WplywContext } from "../../../../../context/wplywContext";
import { useContext, useEffect, useState } from "react";
import { Input, Select } from "antd";
import { useLocation } from "react-router";
import InnerStages from "./InnerStages/InnerStages";
import getFilledPersonOwnIds from "../../../../../components/getFilledPersonOwnIds";
import LinkToSumUp from "../../MainWrapper/LinkToSumUp";
const { TextArea } = Input;
const { Option } = Select;

const getDeepLinkParams = () => {
	const hash = window.location.hash || "";
	const [, search = ""] = hash.split("?");
	const searchParams = new URLSearchParams(search);
	const personid = searchParams.get("personid");
	const transferid = searchParams.get("transferid");

	if (!personid && !transferid) {
		return null;
	}

	return {
		personid: personid ? String(personid) : null,
		transferid: transferid ? String(transferid) : null,
	};
};

const StageForPerson = () => {
	const { wplyw } = useContext(WplywContext);
	const location = useLocation();
	const persons = wplyw?.wplyw_data?.data?.msr_wplywy.msr_persons || [];
	const filledperson = getFilledPersonOwnIds(wplyw);
	const selectedPersonStorageKey = `wplywSelectedPerson:${wplyw?.msr_wplywy_id || "nowy"}`;
	const [deepLink, setDeepLink] = useState(() => getDeepLinkParams());

	useEffect(() => {
		setDeepLink(getDeepLinkParams());
	}, [location.search, location.pathname]);

	// Set the default selected person to the first one whose `own_id` is in `filledperson`
	const defaultPerson = persons.find((person) =>
		filledperson.includes(person.msr_persons_own_id),
	);
	const [selectedPersonId, setSelectedPersonId] = useState(() => {
		if (deepLink?.personid) {
			return persons.find(
				(person) =>
					String(person.msr_persons_own_id) ===
					String(deepLink.personid),
			)?.msr_persons_id;
		}
		const storedPersonId = localStorage.getItem(selectedPersonStorageKey);
		if (storedPersonId) {
			return (
				persons.find(
					(person) =>
						String(person.msr_persons_id) === storedPersonId,
				)?.msr_persons_id || null
			);
		}
		return defaultPerson?.msr_persons_id || null;
	});
	const [selectedPerson, setSelectedPerson] = useState(
		persons.find((person) =>
			deepLink?.personid
				? String(person.msr_persons_own_id) ===
					String(deepLink.personid)
				: person.msr_persons_id === selectedPersonId,
		),
	);

	useEffect(() => {
		if (deepLink?.personid) {
			const deepLinkedPerson = persons.find(
				(person) =>
					String(person.msr_persons_own_id) ===
					String(deepLink.personid),
			);

			if (
				deepLinkedPerson &&
				deepLinkedPerson.msr_persons_id !== selectedPersonId
			) {
				setSelectedPersonId(deepLinkedPerson.msr_persons_id);
				return;
			}
		}

		const selectedPersonStillExists = persons.some(
			(person) => person.msr_persons_id === selectedPersonId,
		);
		if (!selectedPersonStillExists) {
			const storedPersonId = localStorage.getItem(
				selectedPersonStorageKey,
			);
			const storedPerson = persons.find(
				(person) => String(person.msr_persons_id) === storedPersonId,
			);
			setSelectedPersonId(
				storedPerson?.msr_persons_id ||
					defaultPerson?.msr_persons_id ||
					null,
			);
		}
	}, [
		deepLink?.personid,
		persons,
		selectedPersonId,
		defaultPerson,
		selectedPersonStorageKey,
	]);

	useEffect(() => {
		if (selectedPersonId) {
			localStorage.setItem(
				selectedPersonStorageKey,
				String(selectedPersonId),
			);
		}
	}, [selectedPersonId, selectedPersonStorageKey]);

	useEffect(() => {
		setSelectedPerson(
			persons.find((person) =>
				deepLink?.personid
					? String(person.msr_persons_own_id) ===
						String(deepLink.personid)
					: person.msr_persons_id === selectedPersonId,
			),
		);
	}, [wplyw, selectedPersonId, deepLink?.personid]);

	return (
		selectedPerson && (
			<>
				<div
					className="formwithpreview"
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "16px",
					}}
				>
					<div>
						<Select
							placeholder="Wybierz osobę"
							style={{
								width: "100%",
								border: "2px solid #BD8136",
								height: "60px",
							}}
							onChange={(value) => {
								setDeepLink(null);
								window.location.hash = `#/wplywy/${wplyw.msr_wplywy_id}`;
								setSelectedPersonId(value);
								localStorage.setItem(
									selectedPersonStorageKey,
									String(value),
								);
							}}
							className={"personselect"}
							value={selectedPersonId} // Use `selectedPersonId` for controlled behavior
						>
							{persons.map((person) => (
								<Option
									key={person.msr_persons_id}
									value={person.msr_persons_id}
									disabled={
										!filledperson.includes(
											person.msr_persons_own_id,
										)
									}
									style={{ textAlign: "center" }}
								>
									{person.msr_persons_name}{" "}
									{person.msr_persons_lastname} #
									{person.msr_persons_own_id}
									{!filledperson.includes(
										person.msr_persons_own_id,
									)
										? " UZUPEŁNIJ DANE"
										: ""}
								</Option>
							))}
						</Select>
						<div style={{ marginTop: "10px" }}>
							<LinkToSumUp
								wplywid={wplyw.msr_wplywy_id}
								personid={selectedPerson.msr_persons_own_id}
								selectedperson={selectedPerson}
							></LinkToSumUp>
						</div>
						{selectedPerson.msr_persons_majority == "0" ? (
							<div
								style={{
									padding: "10px 20px",
									background: "red",
									color: "white",
									marginTop: "10px",
								}}
							>
								Uwaga! Wypełniasz dane dla osoby{" "}
								<b style={{ fontWeight: 900 }}>
									niepełnoletniej
								</b>{" "}
								lub{" "}
								<b style={{ fontWeight: 900 }}>
									ubezwłasnowolnionej
								</b>
								.
							</div>
						) : (
							<></>
						)}
					</div>
					<InnerStages
						selectedPerson={selectedPerson}
						selectedPersonId={selectedPersonId}
						setSelectedPersonId={setSelectedPersonId}
						deepLink={deepLink}
					></InnerStages>
				</div>
			</>
		)
	);
};

export default StageForPerson;
